module.exports = __webpack_public_path__ + "img/categories-fill.547ad2e7.svg";